<template>
  <div class="main-menu-content">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="logo-box logo--box">
          <a href="#" class="logo"
            ><img src="../assets/images/logo-fill.png" alt="لوگو"
          /></a>
          <div class="user-btn-action">
            <div
              class="
                search-menu-toggle
                icon-element icon-element-sm
                shadow-sm
                mr-2
              "
              data-toggle="tooltip"
              data-placement="top"
              title="جستجو کردن"
            >
              <i class="la la-search"></i>
            </div>
            <div
              class="
                off-canvas-menu-toggle
                cat-menu-toggle
                icon-element icon-element-sm
                shadow-sm
                mr-2
              "
              data-toggle="tooltip"
              data-placement="top"
              title="منوی دسته بندی"
            >
              <i class="la la-th-large"></i>
            </div>
            <div
              class="
                off-canvas-menu-toggle
                main-menu-toggle
                icon-element icon-element-sm
                shadow-sm
              "
              data-toggle="tooltip"
              data-placement="top"
              title="منوی اصلی"
            >
              <i class="la la-bars"></i>
            </div>
          </div>
        </div>
        <!-- end logo-box -->
        <div class="menu-wrapper">
          <div class="nav-left-button d-flex align-items-center">
            <div class="shop-cart user-profile-cart">
              <ul>
                <li>
                  <div class="shop-cart-btn">
                    <div class="avatar-xs">
                      <img
                        class="rounded-full img-fluid"
                        src="../assets/images/small-avatar-1.jpg"
                        alt="تصویر آواتار"
                      />
                    </div>
                  </div>
                  <ul
                    class="
                      cart-dropdown-menu
                      after-none
                      p-0
                      notification-dropdown-menu
                    "
                  >
                    <li>
                      <ul class="generic-list-item">
                        <li>
                          <router-link to="/settings">
                            <i class="la la-gear mr-1"></i> تنظیمات
                          </router-link>
                        </li>

                        <li>
                          <router-link to="/login">
                            <i class="la la-power-off mr-1"></i> خروج
                          </router-link>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <!-- end shop-cart -->
          </div>
        </div>
        <!-- end nav-left-button -->
      </div>
      <!-- end menu-wrapper -->
    </div>
    <!-- end col-lg-10 -->
  </div>
  <!-- end row -->
</template>

<script>
export default {
  name: "Header",
};
</script>

<style></style>
